export { BreakpointService } from './src/services/breakpoint-service';
export { BreakpointSignalService } from './src/services/breakpoint-signal.service';
export { LABORATORY_NOTIFICATION } from './src/services/laboratory-notification.token';
export { ChartComponent } from './src/components/chart/chart.component';
export { ScrollerComponent } from './src/components/scroller/scroller.component';
export { ThousandSeparatorPipe } from './src/pipes/thousand-separator.pipe';
export { TabGroupComponent } from './src/components/tab-group/tab-group.component';
export { NavBarMenu } from './src/interface';
export { TruncatePipe } from './src/pipes/truncate.pipe';
export { FilterEmptyPipe } from './src/pipes/filter-empty.pipe';
export { TimePipe } from './src/pipes/time/time.pipe';
export { RoundPipe } from './src/pipes/round.pipe';
export { StripEmojiPipe } from './src/pipes/strip-emoji.pipe';
export { LaboratoryMenuToggleComponent } from './src/components/menu/menu-toggle/menu-toggle.component';
export { LaboratoryMenuItemComponent } from './src/components/menu/menu-item/menu-item.component';
export { LaboratoryMsToWordsPipe } from './src/pipes/ms-to-words.pipe';
export { ZonedDatePipe, type ZonedDateFormat } from './src/pipes/zoned-date/zoned-date.pipe';
export { LaboratoryTimeZoneProvider } from './src/pipes/zoned-date/zoned-date.time-zone-provider';
export { LaboratoryServerClock } from './src/pipes/zoned-date/server-clock.service';
export { LaboratoryZonedCalendar } from './src/pipes/zoned-date/zoned-calendar.service';
export { LaboratoryRoundComponent } from './src/components/round-button/component/round.component';
export { LabButtonComponent } from './src/components/button/lab-button.component';
export { LabButtonLinkComponent } from './src/components/button/lab-button-link.component';
export { LaboratoryAttachmentChipComponent } from './src/components/attachment-chip/attachment-chip.component';
export {
  LaboratoryIconComponent,
  type LaboratoryIconName,
  type LaboratoryIconSize,
} from './src/components/icon/laboratory-icon.component';
export { MenuButtonComponent } from './src/components/menu-button/menu-button.component';
export { ButtonRowComponent } from './src/components/button-row/button-row.component';
export { StepNavigationService } from './src/services/step-navigation.service';
export {
  ConfirmationDialogComponent,
  ConfirmationDialogData,
} from './src/components/confirmation-dialog/confirmation-dialog.component';
export {
  LaboratoryConfirmDialogComponent,
  type LaboratoryConfirmDialogData,
} from './src/components/confirm-dialog/confirm-dialog.component';
export { LaboratoryConfirmDialogService } from './src/components/confirm-dialog/confirm-dialog.service';
export {
  injectLaboratoryDialogClose,
  injectLaboratoryDialogData,
  type LaboratoryDialogContextOptions,
  LaboratoryInfoDialogService,
  provideLaboratoryDialogContext,
  provideLaboratoryInlineDialog,
} from './src/components/info-dialog/info-dialog.service';
export { LaboratoryCheckboxComponent, LaboratoryCheckboxState } from './src/components/checkbox/checkbox.component';
export { LaboratoryInfoDialogComponent } from './src/components/info-dialog/info-dialog.component';
export { LaboratoryInputComponent, LaboratoryInputState } from './src/components/input/input.component';
export {
  PeriodRangeComponent,
  type PeriodRangeSize,
  type PeriodRangeValue,
  type PeriodRangeSelection,
  type PeriodRangePresetOption,
} from './src/components/period-range/period-range.component';
export {
  LaboratoryTooltipDirective,
  LaboratoryTooltipReferenceDirective,
} from './src/components/tooltip/tooltip.directive';
export { LaboratoryTooltipModule } from './src/components/tooltip/tooltip.module';
export { LaboratoryTabComponent, LaboratoryTabSize, LaboratoryTabType } from './src/components/tabs/tab.component';
export {
  LaboratoryTabChangeEvent,
  LaboratoryTabsComponent,
  LaboratoryTabsItem,
} from './src/components/tabs/tabs.component';
export {
  LaboratorySkeletonComponent,
  LaboratorySkeletonKind,
  LaboratorySkeletonSize,
} from './src/components/skeleton/skeleton.component';
export {
  LaboratorySelectComponent,
  LaboratorySelectIconDirective,
  LaboratorySelectOption,
  LaboratorySelectSize,
  LaboratorySelectState,
} from './src/components/select/select.component';
export { LaboratoryMultiselectComponent } from './src/components/multiselect/multiselect.component';
export {
  LaboratorySegmentedRadioComponent,
  LaboratorySegmentedRadioGroupComponent,
  LaboratorySegmentedRadioOption,
  LaboratorySegmentedRadioSize,
} from './src/components/segmented-radio/segmented-radio.component';
export { LaboratoryRadioComponent } from './src/components/radio/radio.component';
export {
  LaboratoryRadioGroupComponent,
  LaboratoryRadioState,
  LaboratoryRadioAppearance,
} from './src/components/radio/radio-group.component';
export {
  LaboratoryLevelSelectDialogComponent,
  type LaboratoryLevelSelectBadge,
  type LaboratoryLevelSelectBadgeKind,
  type LaboratoryLevelSelectOption,
} from './src/components/level-select-dialog/level-select-dialog.component';
export { LaboratorySwitcherComponent } from './src/components/switcher/switcher.component';
export {
  LaboratoryTableHeadCellComponent,
  type LaboratoryTableSortDirection,
} from './src/components/table-head-cell/table-head-cell.component';
export { type LaboratoryPageEvent, LaboratoryPaginatorComponent } from './src/components/paginator/paginator.component';
export { LaboratoryNoticeComponent, type LaboratoryNoticeType } from './src/components/notice/notice.component';
export { LaboratoryToastComponent, type LaboratoryToastType } from './src/components/toast/toast.component';
export { LaboratorySpinnerComponent } from './src/components/spinner/laboratory-spinner.component';
export { LaboratoryMathKeypadComponent } from './src/components/math-keypad/math-keypad.component';
export {
  LABORATORY_MATH_KEYPAD_DEFAULT_MODE,
  LABORATORY_MATH_KEYPAD_MODES,
  type LaboratoryMathKey,
  type LaboratoryMathKeypadMode,
  type LaboratoryMathKeypadModeKeys,
} from './src/components/math-keypad/math-keypad.symbols';
export {
  LABORATORY_EMPTY_STATE_ILLUSTRATIONS,
  type LaboratoryEmptyStateAppearance,
  LaboratoryEmptyStateComponent,
  type LaboratoryEmptyStateSize,
  type LaboratoryEmptyStateType,
} from './src/components/empty-state/empty-state.component';
export {
  LaboratoryProgressBarComponent,
  type LaboratoryProgressBarSize,
  type LaboratoryProgressBarType,
} from './src/components/progress-bar/progress-bar.component';
export { LaboratorySidePanelComponent } from './src/components/side-panel/side-panel.component';
export { LaboratoryBottomSheetComponent } from './src/components/bottom-sheet/bottom-sheet.component';
// Storybook-only хелперы (`decorators`/`globalTypes`/`parameters`) НЕ реэкспортим
// из этого app-facing barrel: они тянут `@storybook/angular` в граф приложения
// (vite-dev не tree-shake'ит barrel-реэкспорт → падение на бутстрапе). Сторибук-
// конфиги импортят их напрямую из `./src/storybook/laboratory-storybook`.
// Нужен историям приложений: у них макеты в продуктовых Figma-файлах, а
// относительный кросс-проектный импорт запрещён границами модулей Nx.
export { figmaRef, FIGMA_FILE_KEY, type FigmaRef } from './.storybook/figma';
export {
  ADAPTIVE_VIEWPORTS,
  adaptiveViewport,
  validateComponentWidth,
  type Breakpoint,
} from './src/storybook/adaptive-viewports';
export {
  LABORATORY_THEME_PREFERENCE_STORAGE_KEY,
  LaboratoryThemeService,
  isLaboratoryThemePreference,
  type LaboratoryTheme,
  type LaboratoryThemePreference,
} from './src/theme/laboratory-theme.service';
export { LaboratoryPageThemeDirective } from './src/theme/laboratory-page-theme.directive';
export { LaboratoryThemeSwitcherComponent } from './src/components/theme-switcher/theme-switcher.component';
